'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'circle-notch';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f1ce';
var svgPathData = ['', 'M223.7 17.6C225.4 26.3 219.8 34.7 211.2 36.5 108.9 57.2 32 147.6 32 256 32 379.7 132.3 480 256 480S480 379.7 480 256c0-108.4-76.9-198.8-179.2-219.5-8.7-1.8-14.3-10.2-12.5-18.9S298.5 3.4 307.2 5.1C424 28.8 512 132.1 512 256 512 397.4 397.4 512 256 512S0 397.4 0 256C0 132.1 88 28.8 204.8 5.1 213.5 3.4 221.9 9 223.7 17.6z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircleNotch = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;